// @ts-nocheck
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TableIcon, SettingsIcon, ListIcon, ShieldIcon, HelpCircleIcon } from 'lucide-react';

import { Link } from 'react-router-dom';
import { GetFlexValueSetList } from '@store/NTX/FlexValue/flexValueSetSlice';
import { Card, CardBody } from '@components/card/card';
import ModalComponent from '@components/Modal/ModalComponent';
import AddFlexValueSet from './FlexValueSet/AddFlexValueSet';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import AddFlexValue from './FlexValue/AddFlexValue';

const ListSystem = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);
  const dispatch = useDispatch();
  const { FlexValueSetList, loading } = useSelector(state => state.FlexValueSet);

  useEffect(() => {
    dispatch(GetFlexValueSetList());
  }, [dispatch]);

  const getBadgeProps = option => {
    if (option.formatType === 'T') {
      return {
        text: i18n.language === 'ar' ? 'جدول' : 'Tabular',
        className: 'bg-primary text-white',
        icon: <TableIcon size={16} className='me-1' />
      };
    }
    if (option.formatType === 'D') {
      return {
        text: i18n.language === 'ar' ? 'قائمة منشأة' : 'Custom List',
        className: 'bg-warning text-dark',
        icon: <SettingsIcon size={16} className='me-1' />
      };
    }
    if (option.formatType === 'L') {
      return {
        text: i18n.language === 'ar' ? 'قائمة عامة' : 'Public List',
        className: 'bg-info text-dark',
        icon: <ListIcon size={16} className='me-1' />
      };
    }
    if (option.isSystem) {
      return {
        text: i18n.language === 'ar' ? 'حقل نظام' : 'System Field',
        className: 'bg-secondary text-white',
        icon: <ShieldIcon size={16} className='me-1' />
      };
    }
    return {
      text: option.validationType,
      className: 'bg-light text-dark',
      icon: <HelpCircleIcon size={16} className='me-1' />
    };
  };

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Type'), key: 'Type' },
    { title: t(''), key: 'action', className: 'text-end  ' }
  ];

  const tableData = FlexValueSetList?.map(item => {
    let rowClass;
    const badgeProps = getBadgeProps(item); // استخدم الدالة هنا

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      // Type: (
      //   <span
      //     className={`badge ${
      //       item.formatType === 'T'
      //         ? 'bg-primary'
      //         : item.formatType === 'D'
      //         ? 'bg-success'
      //         : item.formatType === 'L'
      //         ? 'bg-warning text-dark'
      //         : 'bg-secondary'
      //     }`}
      //   >
      //     {item.formatType === 'T'
      //       ? 'جدول في النظام'
      //       : item.formatType === 'D'
      //       ? 'قائمة ديناميكية'
      //       : item.formatType === 'L'
      //       ? 'قائمة نظام ثابته'
      //       : 'حقل نظام'}
      //   </span>
      // ),

      Type: (
        <span className={`badge ${badgeProps.className}`}>
          {badgeProps.icon}
          {badgeProps.text}
        </span>
      ),
      action: item.formatType === 'D' && (
        <div className='btn-group'>
          {HasPermission('NtxAddFlexValueSystemList') && (
            <button
              type='button'
              // onClick={() => Navigate(`${item.id}/AddFlexValue`)}
              onClick={() => setItem(item)}
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddFlexValue'
            >
              <i className='fab fa-lg fa-fw me-2 fa-elementor'></i>
              {t('Values')}
            </button>
          )}
        </div>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  const titleModal = () => {
    return (
      <div className=''>
        {t('AddValues')}
        {'  '}
        <span className='text-theme'>{`(${i18n.language === 'en' ? item?.name : item?.name2})`}</span>
      </div>
    );
  };

  //________________________________

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: t('SystemLists'),
              link: null
            }
          ]}
          PageName={t('SystemLists')}
        />

        <div className='ms-auto'>
          {HasPermission('NtxAddsyStemList') && (
            <Link
              to=''
              className='btn btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddFlexValueSet'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddNewList')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
      <ModalComponent title={t('AddNewList')} id='modalAddFlexValueSet' size='lg'>
        {show && <AddFlexValueSet />}
      </ModalComponent>

      <ModalComponent title={titleModal()} id='modalAddFlexValue' size='lg'>
        {item && <AddFlexValue id={item?.id} />}
      </ModalComponent>
    </>
  );
};

export default ListSystem;
